import { render, staticRenderFns } from "./ItemColorTiles.vue?vue&type=template&id=7bf39c42&scoped=true&"
import script from "./ItemColorTiles.vue?vue&type=script&lang=ts&"
export * from "./ItemColorTiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf39c42",
  null
  
)

export default component.exports